import React from 'react';
import { Meteor } from 'meteor/meteor';
import { Route, Link } from 'react-router';
import { Reactive } from '../common/Reactive.mixin.js';

import { Roles } from 'roles';

import { AlertSchema, Alerts } from '../../collections/alerts/alerts';

import {
  Well,
  Table,
  Button,
  Breadcrumb,
  Col,
  BPanel
} from '@sketchpixy/rubix';

import MgfTableComponent from '../common/mgfTable';

@Reactive({
	subscriptions: ["alerts"],
	alerts: Alerts.find({}, {order: {createdAt: 1}}),
})
export default class AlertListPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	render() {
		return (
			<div> 
				<Breadcrumb>  
					<Breadcrumb.Item>
						Alertes
					</Breadcrumb.Item>
					<Breadcrumb.Item active>
						Liste des alertes
					</Breadcrumb.Item>
					<Breadcrumb.Item>
						{ Roles.userHasPermission(Meteor.userId(), 'alerts.insert') &&
							<Link to="/alerts/add"><Button bsStyle="success">Ajouter</Button></Link> }
					</Breadcrumb.Item>
				</Breadcrumb>
				<BPanel header="Liste des alertes">
					{ this.props.isReady && 
						<MgfTableComponent fields={AlertSchema._schema} list={this.props.alerts} type='alerts'></MgfTableComponent> }
				</BPanel>
			</div>
		);
	}
}

AlertListPage.propTypes = {
  places: React.PropTypes.array.isRequired,
};



/** WEBPACK FOOTER **
 ** ./src/universal/components/alerts/AlertList.page.js
 **/